// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p7-0";
export var discountCodeInput = "_p7-1";